import { render, staticRenderFns } from "./OilStockStatus.vue?vue&type=template&id=43409ba8&scoped=true&"
import script from "./OilStockStatus.vue?vue&type=script&lang=js&"
export * from "./OilStockStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43409ba8",
  null
  
)

export default component.exports